import { z } from 'zod';

// Document types
export const documentTypeSchema = z.enum(['proposal', 'solution-architecture', 'sla']);
export type DocumentType = z.infer<typeof documentTypeSchema>;

// Generate document request
export const generateDocumentRequestSchema = z.object({
  type: documentTypeSchema,
  instructions: z.string().min(1, 'Instructions are required'),
  folderId: z.string().nullable(),
  locale: z.string().optional().default('es'),
});

export type GenerateDocumentRequest = z.infer<typeof generateDocumentRequestSchema>;

// Update file content request
export const updateFileContentRequestSchema = z.object({
  content: z.string(),
});

export type UpdateFileContentRequest = z.infer<typeof updateFileContentRequestSchema>;
